import type { IconData } from '@stacksjs/iconify-core'

export const chevronCircleRightF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m11.828 10l-3.535 3.536a1 1 0 0 0 1.414 1.414l4.243-4.243a1 1 0 0 0 0-1.414L9.707 5.05a1 1 0 0 0-1.414 1.414zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronCircleRightF
